﻿function markAsLoading() {
    $('#car-launch-results-container').text('').html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}

function reloadQuery() {
    var State = History.getState();
    $.ajaxSetup({cache: false});
    $.get('/up-sold-car-launch/running-costs/query', State.data, function (response) {
        $('#car-launch-query-container').replaceWith(response);
    });
}

function setOperatingCycle() {
    $.get("/cap-operating-cycles/miles/" + $('#DefaultOperatingCycleId').val(), function (response) {
        $("#Miles").val(response);
    });
    $.get("/cap-operating-cycles/years/" + $('#DefaultOperatingCycleId').val(), function (response) {
        $("#Years").val(response);
    });
}

function buildUpQueryString(data) {
    var queryString = "";
    var operatingCycleDefault = $('#OperatingCycleId option').eq(0).val();
    if (data.OperatingCycleId != operatingCycleDefault) {
        if (queryString.length > 0) queryString += "&";
        queryString += "Years=" + data.Years + "&Miles=" + data.Miles + "&ModelGroupId=" + data.ModelGroupId + "&DerivativeId=" + data.DerivativeId;
    }
    if (queryString.length > 0) queryString += "&";
    if (parseInt(data.imageId) > 0) {
        queryString += "image=" + data.imageId;
    } else {
        queryString += "image=";
    }
    if (data.ModelYear !== "")
        queryString += "&ModelYear=" + data.ModelYear;
    return "?" + queryString;
}

function getData(page) {
    var operatingCycleId = $('#OperatingCycleId').val();
    var miles = $('#Miles').val();
    var years = $('#Years').val();
    var modelGroupId = $('#ModelGroupId').val();
    var imageId = $('#Image').val();
    var derivativeId = $('#DerivativeId').val();
    var modelYear = $('#ModelYear').val();
    return {
        OperatingCycleId: operatingCycleId,
        Miles: miles,
        Years: years,
        DerivativeId: derivativeId,
        imageId: imageId,
        ModelGroupId: modelGroupId,
        ModelYear: modelYear
    };
}

function updateRunningCostsLogic(page) {
    var data = getData(page);
    History.pushState(data, $('title').html(), location.pathname + buildUpQueryString(data));
}

window.updateRunningCosts = function () {
    updateRunningCostsLogic(1);
}

function onImageSliderChange(event) {
    //console.log($(this).find(".item.active").data('image'));
    var image = $(this).find(".item.active").data('image-id');
    $("#Image").val(image);
    window.updateRunningCosts();
}

function onChangeFilters(event) {
    var currentDropdown = ($(this).attr("name"));
    if (currentDropdown === "OperatingCycleId") {
        var derivativeId = $("#DerivativeId").val();
        if (parseInt(derivativeId) > 0) {
            var id = $(this).val();
            $.get("/cap-operating-cycles/miles/" + id, function (response) {
                $("#Miles").val(response);
                $.get("/cap-operating-cycles/years/" + id, function (response) {
                    $("#Years").val(response);
                    window.updateRunningCosts();
                });
            });
        } else {
            alert("please select a derivative first");
        }
    } else if (currentDropdown == "DerivativeId") {
        $("#DerivativeId").val($(this).val());
        window.updateRunningCosts();
    }
}

function validateCustomForm() {
    $("#car-launch-contact-box").validate({
        rules: {
            Name: {
                required: true
            },
            Telephone: {
                require_from_group: [1, ".phone-group"]
            },
            Email: {
                require_from_group: [1, ".phone-group"]
            }
        },
        messages: {
            Name: "Name is required.",
            Telephone: "Please complete either email or phone number",
            Email: "Please complete either email or phone number"
        }
    });
}


function updateState() { // Note: We are using statechange instead of popstate#
    markAsLoading();
    reloadQuery();
    var State = History.getState();
    setTimeout(
        function () {
            $.get('/up-sold-car-launch/running-costs/results', State.data, function (response) {
                $('#car-launch-results-container').replaceWith(response);
            });
            $.get('/up-sold-car-launch/fact-sheet/results', State.data, function (response) {
                $('#car-launch-fact-sheet-container').replaceWith(response);
            });
        }, 500);
}


export function setupUpsoldCarLaunch() {
    if (!$('[data-upsold-car-launch]').length)
        return;

    $.featherlight.defaults.afterOpen = validateCustomForm;
    jQuery.validator.setDefaults({
        success: "valid"
    });
    setOperatingCycle();
    $(document).on('change', '[data-car-launch-running-costs] select', onChangeFilters);
    $('a.carousel-control-down').click(function () {
        $('html, body').animate({
            scrollTop: $("#name").offset().top - 160
        });
        return false;
    });
    $('#carousel-example-generic').bind('slid.bs.carousel', onImageSliderChange);
    $("#carousel-example-generic").swiperight(function () {
        $(this).carousel('prev');
    });
    $("#carousel-example-generic").swipeleft(function () {
        $(this).carousel('next');
    });
    var heights = $("div.sameheight").map(function () {
            return $(this).height();
        }).get(),
        maxHeight = Math.max.apply(null, heights);
    $("div.sameheight").height(maxHeight);
    $(document).on("submit", "[data-car-launch-contact-form]", function (e) {
        $('[data-upsold-contact-button]').disabled = true;
        var form = $(e.target);
        if (!form.valid())
            return;
        e.preventDefault();
        $.post(form.attr("action"), form.serialize(), function (response) {
            $("[data-success-message]").empty().append("<section><div class='container'><div class='padding-top-15'><div class='alert alert-success'>Thank you for contacting us. You will receive a response soon.</div></div></div></section>");
            var currentfeatherlight = $.featherlight.current();
            if (currentfeatherlight) {
                currentfeatherlight.close();
            }
        });
    });
    //History.Adapter.bind(window, 'statechange', updateState);
}